export default {
  income360pay: null,
};
